import React, { useMemo, useState } from 'react';
import { Menu, Tooltip } from 'antd';
import styles from './styles/Shortcuts.less';
import { calcShortcutInterval } from '@utils';
import { DATE_SHORTCUTS } from '@utils/constants';

const Shortcuts = ({ shortcuts, selected = 'custom', onChange, live = false, liveMenuTooltip }) => {
  const defaultIntervalForCustom = calcShortcutInterval(DATE_SHORTCUTS.last6Hours);
  const [previousSelectedInterval, setPreviousSelectedInterval] =
    useState(defaultIntervalForCustom);

  const intervalByShortcutKey = useMemo(
    () => new Map(shortcuts.map(([shortcut, interval]) => [shortcut, interval])),
    [shortcuts],
  );

  const hasLast15Shortcut = useMemo(
    () => shortcuts.some(([shortcut]) => shortcut === DATE_SHORTCUTS.last15Mins),
    [shortcuts],
  );

  const onMenuSelect = ({ key }) => {
    let selectedInterval;
    if (key === 'custom') {
      selectedInterval = previousSelectedInterval;
    } else if (key === 'live') {
      selectedInterval = undefined;
    } else {
      selectedInterval = intervalByShortcutKey.get(key);
    }
    setPreviousSelectedInterval(selectedInterval);
    onChange(selectedInterval, key);
  };

  const elements = shortcuts.map(([shortcut]) => {
    const rtLabel =
      shortcut === DATE_SHORTCUTS.last15Mins ? (
        <div className={styles.rtshortcut}>
          <div className={styles.liveModeMarker} />
          {shortcut}
        </div>
      ) : (
        shortcut
      );
    const labeled =
      liveMenuTooltip && shortcut === DATE_SHORTCUTS.last15Mins ? (
        <Tooltip title={liveMenuTooltip} placement="right">
          <span className={styles.liveShortcutTooltipAnchor}>{rtLabel}</span>
        </Tooltip>
      ) : (
        rtLabel
      );
    return (
      <Menu.Item key={shortcut} id={`date-picker-${shortcut}`.toLowerCase()}>
        {labeled}
      </Menu.Item>
    );
  });

  const liveShortcutLabel = (
    <div className={styles.rtshortcut}>
      <div className={styles.liveModeMarker} />
      {'Live'}
    </div>
  );

  return (
    <Menu selectedKeys={[selected]} className={styles.shortcuts} onClick={onMenuSelect}>
      {live && !hasLast15Shortcut ? (
        <Menu.Item key="live" id="date-picker-live">
          {liveMenuTooltip ? (
            <Tooltip title={liveMenuTooltip} placement="right">
              <span className={styles.liveShortcutTooltipAnchor}>{liveShortcutLabel}</span>
            </Tooltip>
          ) : (
            liveShortcutLabel
          )}
        </Menu.Item>
      ) : null}
      {elements}
      <Menu.Item key="custom" id="date-picker-custom">
        Custom
      </Menu.Item>
    </Menu>
  );
};

export default Shortcuts;
